// plugins/fetchInstances.ts
export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()
  // Cria a instância customizada com o $fetch do Nuxt para a Api do Moodle
  const apiMoodle = $fetch.create({
    baseURL: config.public.baseURL,
    headers: { 'Content-Type': 'application/json' }
  })

  const reqMoodle = $fetch.create({
    baseURL: config.public.baseURL
  })

  /**
   * Inscreve o usuário logado em um curso via sesskey (auto-inscrição).
   * Depende da sessão ativa do Moodle (cookies) + sesskey como CSRF token.
   *
   * @param courseId - ID do curso a ser inscrito
   * @returns Promise com a resposta do Moodle
   *
   * @example
   * const { $enrolMoodle } = useNuxtApp()
   * await $enrolMoodle(42)
   */
  const enrolMoodle = (courseId: number): Promise<void> => {
    const userStore = useUserStore()

    if (!userStore.isLoggedIn) {
      return Promise.reject(new Error('Usuário não autenticado.'))
    }

    const body = new URLSearchParams({
      id: String(courseId),
      sesskey: userStore.sesskey,
      action: 'enrol',
    })

    return $fetch('/enrol/index.php?id='+courseId, {
      baseURL: config.public.baseURL,
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      credentials: 'include', // envia os cookies de sessão do Moodle
      body: body.toString(),
    })
  }

  const fetchWS = $fetch.create({
    baseURL: config.public.baseURL + '/webservice/rest/server.php',
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  })

  // Injeta globalmente como $apiMoodle
  return {
    provide: {
      apiMoodle,
      reqMoodle,
      enrolMoodle,
      fetchWS,
    }
  }
})

